// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ------------------------------------------------------------------
   Print / save-as-PDF.
   Recruiters print things. Without this the page would come out as a
   dark screenshot with half its content collapsed shut.
------------------------------------------------------------------- */

@media print {
  @page {
    margin: 14mm 12mm;
  }

  /* Force the light palette regardless of the visitor's theme. */
  :root,
  :root[data-theme="dark"],
  :root[data-theme="light"] {
    --bg: #ffffff;
    --bg-elev: #ffffff;
    --surface: transparent;
    --surface-strong: transparent;
    --surface-hover: transparent;
    --line: #d4d8e2;
    --line-strong: #9aa2b4;
    --text: #000000;
    --text-soft: #23272f;
    --text-dim: #4a5160;
    --accent: #0b5f78;
    --accent-2: #4a2f9c;
    --accent-text: none;
    --grad-brand: none;
    --shadow-md: none;
    --shadow-lg: none;
  }

  body {
    background: #fff !important;
    color: #000 !important;
    font-size: 10.5pt;
    line-height: 1.42;
  }

  /* Display type is for screens; paper wants the space for content. */
  .page-hero__title { font-size: 15pt; margin-block: 0.1rem 0.3rem; }
  .section__title { font-size: 13pt; }
  .tl-card__role { font-size: 12pt; }
  .edu__degree, .pcard__title, .skill-group__title { font-size: 11pt; }

  /* Screen furniture that means nothing on paper. */
  body::before,
  body::after,
  .nav,
  .drawer,
  .progress,
  .particles,
  .palette__scrim,
  .toast,
  .footer,
  .hero__scroll,
  .marquee,
  .skip-link,
  .page-hero__lede,
  .terminal__hint,
  .cta,
  .skill-filters,
  .tl-card__toggle,
  .activity,
  .arch__panel-foot {
    display: none !important;
  }

  .page { padding-top: 0; }
  .section { padding-block: 0.6rem; }
  .shell { max-width: none; padding-inline: 0; }

  /* Reveal-on-scroll never runs in a print context. */
  .reveal {
    opacity: 1 !important;
    transform: none !important;
  }

  /* Every collapsed role has to be open on paper. */
  .tl-card__panel {
    grid-template-rows: 1fr !important;
  }
  .tl-card__panel > div { overflow: visible !important; }
  .tl-card__head { padding-bottom: 0.4rem; }

  .card,
  .arch__canvas,
  .arch__panel {
    border: 1px solid var(--line) !important;
    background: none !important;
    backdrop-filter: none !important;
    box-shadow: none !important;
    page-break-inside: avoid;
    break-inside: avoid;
  }
  .card--spot::before { display: none !important; }

  .accent-text {
    background: none !important;
    -webkit-text-fill-color: #000 !important;
    color: #000 !important;
  }

  .eyebrow {
    border: 0;
    padding: 0;
    color: var(--accent) !important;
  }
  .eyebrow::before { display: none; }

  .chip {
    border: 1px solid var(--line);
    color: #23272f !important;
  }

  .tl-item { padding-left: 0; page-break-inside: avoid; break-inside: avoid; }
  .tl-item__node { display: none; }
  .timeline::before { display: none; }

  .page-hero { padding-block: 0 0.8rem; text-align: left; }
  .page-hero__lede { margin-inline: 0; }

  /* Keep headings with the content that follows them. */
  h1, h2, h3 { page-break-after: avoid; break-after: avoid; }
  .section__head { page-break-after: avoid; break-after: avoid; margin-bottom: 0.8rem; }

  /* Print the URL behind each outbound link — the paper can't be clicked. */
  a[href^="http"]::after {
    content: " (" attr(href) ")";
    font-size: 8.5pt;
    color: #4a5160;
    word-break: break-all;
  }
  .icon-btn::after,
  .btn::after,
  .activity__row::after { content: "" !important; }

  .btn { display: none !important; }

  /* A print-only masthead, so the page identifies itself on paper. */
  .print-head { display: block !important; margin-bottom: 0.9rem; }
  .print-head h1 { font-size: 20pt; margin-bottom: 0.2rem; }
  .print-head p { font-size: 9.5pt; color: #23272f; }
  .print-head hr { margin-top: 0.5rem; background: var(--line-strong); opacity: 1; }
  .print-head a[href^="http"]::after { content: "" !important; }
}

.print-head { display: none; }
`, "",{"version":3,"sources":["webpack://./src/styles/print.css"],"names":[],"mappings":"AAAA;;;;qEAIqE;;AAErE;EACE;IACE,iBAAiB;EACnB;;EAEA,+DAA+D;EAC/D;;;IAGE,aAAa;IACb,kBAAkB;IAClB,sBAAsB;IACtB,6BAA6B;IAC7B,4BAA4B;IAC5B,eAAe;IACf,sBAAsB;IACtB,eAAe;IACf,oBAAoB;IACpB,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,2BAA2B;IAC3B,sBAAsB;IACtB,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA,oEAAoE;EACpE,oBAAoB,eAAe,EAAE,2BAA2B,EAAE;EAClE,kBAAkB,eAAe,EAAE;EACnC,iBAAiB,eAAe,EAAE;EAClC,mDAAmD,eAAe,EAAE;;EAEpE,kDAAkD;EAClD;;;;;;;;;;;;;;;;;;;IAmBE,wBAAwB;EAC1B;;EAEA,QAAQ,cAAc,EAAE;EACxB,WAAW,qBAAqB,EAAE;EAClC,SAAS,eAAe,EAAE,iBAAiB,EAAE;;EAE7C,oDAAoD;EACpD;IACE,qBAAqB;IACrB,0BAA0B;EAC5B;;EAEA,kDAAkD;EAClD;IACE,kCAAkC;EACpC;EACA,wBAAwB,4BAA4B,EAAE;EACtD,iBAAiB,sBAAsB,EAAE;;EAEzC;;;IAGE,wCAAwC;IACxC,2BAA2B;IAC3B,gCAAgC;IAChC,2BAA2B;IAC3B,wBAAmB;IAAnB,mBAAmB;EACrB;EACA,sBAAsB,wBAAwB,EAAE;;EAEhD;IACE,2BAA2B;IAC3B,wCAAwC;IACxC,sBAAsB;EACxB;;EAEA;IACE,SAAS;IACT,UAAU;IACV,+BAA+B;EACjC;EACA,mBAAmB,aAAa,EAAE;;EAElC;IACE,6BAA6B;IAC7B,yBAAyB;EAC3B;;EAEA,WAAW,eAAe,EAAE,wBAAmB,EAAnB,mBAAmB,EAAE;EACjD,iBAAiB,aAAa,EAAE;EAChC,oBAAoB,aAAa,EAAE;;EAEnC,aAAa,uBAAuB,EAAE,gBAAgB,EAAE;EACxD,mBAAmB,gBAAgB,EAAE;;EAErC,sDAAsD;EACtD,aAAa,uBAAkB,EAAlB,kBAAkB,EAAE;EACjC,iBAAiB,uBAAkB,EAAlB,kBAAkB,EAAE,qBAAqB,EAAE;;EAE5D,0EAA0E;EAC1E;IACE,4BAA4B;IAC5B,gBAAgB;IAChB,cAAc;IACd,qBAAqB;EACvB;EACA;;0BAEwB,sBAAsB,EAAE;;EAEhD,OAAO,wBAAwB,EAAE;;EAEjC,mEAAmE;EACnE,cAAc,yBAAyB,EAAE,qBAAqB,EAAE;EAChE,iBAAiB,eAAe,EAAE,qBAAqB,EAAE;EACzD,gBAAgB,gBAAgB,EAAE,cAAc,EAAE;EAClD,iBAAiB,kBAAkB,EAAE,8BAA8B,EAAE,UAAU,EAAE;EACjF,qCAAqC,sBAAsB,EAAE;AAC/D;;AAEA,cAAc,aAAa,EAAE","sourcesContent":["/* ------------------------------------------------------------------\n   Print / save-as-PDF.\n   Recruiters print things. Without this the page would come out as a\n   dark screenshot with half its content collapsed shut.\n------------------------------------------------------------------- */\n\n@media print {\n  @page {\n    margin: 14mm 12mm;\n  }\n\n  /* Force the light palette regardless of the visitor's theme. */\n  :root,\n  :root[data-theme=\"dark\"],\n  :root[data-theme=\"light\"] {\n    --bg: #ffffff;\n    --bg-elev: #ffffff;\n    --surface: transparent;\n    --surface-strong: transparent;\n    --surface-hover: transparent;\n    --line: #d4d8e2;\n    --line-strong: #9aa2b4;\n    --text: #000000;\n    --text-soft: #23272f;\n    --text-dim: #4a5160;\n    --accent: #0b5f78;\n    --accent-2: #4a2f9c;\n    --accent-text: none;\n    --grad-brand: none;\n    --shadow-md: none;\n    --shadow-lg: none;\n  }\n\n  body {\n    background: #fff !important;\n    color: #000 !important;\n    font-size: 10.5pt;\n    line-height: 1.42;\n  }\n\n  /* Display type is for screens; paper wants the space for content. */\n  .page-hero__title { font-size: 15pt; margin-block: 0.1rem 0.3rem; }\n  .section__title { font-size: 13pt; }\n  .tl-card__role { font-size: 12pt; }\n  .edu__degree, .pcard__title, .skill-group__title { font-size: 11pt; }\n\n  /* Screen furniture that means nothing on paper. */\n  body::before,\n  body::after,\n  .nav,\n  .drawer,\n  .progress,\n  .particles,\n  .palette__scrim,\n  .toast,\n  .footer,\n  .hero__scroll,\n  .marquee,\n  .skip-link,\n  .page-hero__lede,\n  .terminal__hint,\n  .cta,\n  .skill-filters,\n  .tl-card__toggle,\n  .activity,\n  .arch__panel-foot {\n    display: none !important;\n  }\n\n  .page { padding-top: 0; }\n  .section { padding-block: 0.6rem; }\n  .shell { max-width: none; padding-inline: 0; }\n\n  /* Reveal-on-scroll never runs in a print context. */\n  .reveal {\n    opacity: 1 !important;\n    transform: none !important;\n  }\n\n  /* Every collapsed role has to be open on paper. */\n  .tl-card__panel {\n    grid-template-rows: 1fr !important;\n  }\n  .tl-card__panel > div { overflow: visible !important; }\n  .tl-card__head { padding-bottom: 0.4rem; }\n\n  .card,\n  .arch__canvas,\n  .arch__panel {\n    border: 1px solid var(--line) !important;\n    background: none !important;\n    backdrop-filter: none !important;\n    box-shadow: none !important;\n    break-inside: avoid;\n  }\n  .card--spot::before { display: none !important; }\n\n  .accent-text {\n    background: none !important;\n    -webkit-text-fill-color: #000 !important;\n    color: #000 !important;\n  }\n\n  .eyebrow {\n    border: 0;\n    padding: 0;\n    color: var(--accent) !important;\n  }\n  .eyebrow::before { display: none; }\n\n  .chip {\n    border: 1px solid var(--line);\n    color: #23272f !important;\n  }\n\n  .tl-item { padding-left: 0; break-inside: avoid; }\n  .tl-item__node { display: none; }\n  .timeline::before { display: none; }\n\n  .page-hero { padding-block: 0 0.8rem; text-align: left; }\n  .page-hero__lede { margin-inline: 0; }\n\n  /* Keep headings with the content that follows them. */\n  h1, h2, h3 { break-after: avoid; }\n  .section__head { break-after: avoid; margin-bottom: 0.8rem; }\n\n  /* Print the URL behind each outbound link — the paper can't be clicked. */\n  a[href^=\"http\"]::after {\n    content: \" (\" attr(href) \")\";\n    font-size: 8.5pt;\n    color: #4a5160;\n    word-break: break-all;\n  }\n  .icon-btn::after,\n  .btn::after,\n  .activity__row::after { content: \"\" !important; }\n\n  .btn { display: none !important; }\n\n  /* A print-only masthead, so the page identifies itself on paper. */\n  .print-head { display: block !important; margin-bottom: 0.9rem; }\n  .print-head h1 { font-size: 20pt; margin-bottom: 0.2rem; }\n  .print-head p { font-size: 9.5pt; color: #23272f; }\n  .print-head hr { margin-top: 0.5rem; background: var(--line-strong); opacity: 1; }\n  .print-head a[href^=\"http\"]::after { content: \"\" !important; }\n}\n\n.print-head { display: none; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
